module.exports = __webpack_public_path__ + "img/axt_px.a6c74919.png";